/* eslint-disable quotes */
import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import { FormattedMessage } from "react-intl";

import { Pluggable } from "@folio/stripes/core";

const SafeDeleteInstanceRoute = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      // redirectTo="safe-delete-instance"
    >
      <FormattedMessage
        id="ui-inventory.templatesPluginNotAvailable"
        defaultMessage="Templates plugin not available"
      />
    </Pluggable>
  );
};

SafeDeleteInstanceRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default SafeDeleteInstanceRoute;